// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_5f-6";
export var headerCell = "_5f-2";
export var rowWrapper = "_5f-4";
export var stickyAggregationCell = "_5f-a";
export var stickyAggregationRow = "_5f-7";
export var stickyColumnCell = "_5f-9";
export var stickyColumnHeaderCell = "_5f-8";
export var table = "_5f-1";
export var virtualRowWrapper = "_5f-5";
export var virtualTableContainer = "_5f-0";
export var white = "_5f-3";